import React, { useEffect, useState } from "react";
import axios from "axios";
import { test_ip } from "../services/constants";
import { Dashen_Constants } from "../services/dashen_bank_constants";
import Loading from "../components/Loading";
// import { check_error_code } from "../services/error_string";
import { Alert } from "@mui/material";
const appSecret = Dashen_Constants.appSecret;
const CourierInvoice = () => {
  const storedCart = JSON.parse(localStorage.getItem("courier_cart"));
  var cart_id = storedCart._id;
  const orderPayment = JSON.parse(localStorage.getItem("courier_op"));
  var user = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);

  // Check if the storedCart exists and has pickup and destination addresses
  // if (
  //   !storedCart ||
  //   !storedCart.pickup_addresses ||
  //   !storedCart.destination_addresses
  // ) {
  //   return <h1>No Courier Data Available</h1>;
  // }

  // Extracting sender (pickup) and receiver (destination) details
  const pickup = storedCart.pickup_addresses[0];
  const destination = storedCart.destination_addresses[0];

  const senderName = pickup.user_details.name;
  const senderPhone = pickup.user_details.phone;
  const pickupAddress = pickup.address;

  const receiverName = destination.user_details.name;
  const receiverPhone = destination.user_details.phone;
  const dropoffAddress = destination.address;
  useEffect(() => {
    window.callbacktocourier = callbacktocourier;
  }, []);
  // Extract payment details
  const paymentDetails = orderPayment || {}; // Default to an empty object if orderPayment is null
  const totalPrice = paymentDetails.total || 0;
  const distance = paymentDetails.total_distance || 0; // Replace with the correct property if different
  const time = paymentDetails.total_time || 0; // Replace with the correct property if different
  const servicePrice = paymentDetails.total_service_price || 0; // Replace with the correct property if different

  const handlePlaceOrder = async () => {
    console.log("Order placed!");
    // console.log(data);
    setLoading(true);
    const req = {
      title: "Zmall Courier Order",
      amount: totalPrice + "", // Ensure the amount is a string
      billRefNo: String(orderPayment.unique_id), // Replace with actual reference
    };

    try {
      // Make the POST request with axios
      const res = await axios.post(
        `${test_ip}admin/dashen_super_app_test`,
        req,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const response = res.data; // Accessing the actual data from the response
      console.log("Response from server:", response);

      if (response.success) {
        // Initiate payment in super app
        const sa_request_payload = JSON.stringify({
          functionName: "initiatePayment",
          params: {
            orderPayload: response.orderPayload,
            authPayload: {
              xAPiKey: appSecret,
              xAccessToken: user.token,
            },
            callbackName: "callbacktocourier", // Define your callback handler
          },
        });

        // Check if Dashen Bank super app is available
        if (window.dashenbanksuperapp) {
          window.dashenbanksuperapp.send(sa_request_payload);
        } else {
          setError(["Somthing Went Wrong..."]);
          console.log("Dashen Bank Super App not found.");
        }
      } else {
        setError(["payment not succesfull"]);
        console.error("Payment order creation failed:", response.message);
      }
    } catch (error) {
      console.error("Error during payment order creation:", error);
      setError(["Somthing went wrong"]);
    } finally {
      // This block will always execute
      setLoading(false); // Set loading to false when the API call is complete (whether success or error)
    }
    // const req = {
    //   title: "Zmall Courier Order",
    //   amount: totalPrice + "", // Ensure the amount is a string
    //   billRefNo: String(orderPayment.unique_id), // Replace with actual reference
    // };

    // axios
    //   .post(`${test_ip}admin/dashen_super_app_test`, req, {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //   .then((res) => {
    //     const response = res.data; // Accessing the actual data from response
    //     console.log("Response from server:", response);

    //     if (response.success) {
    //       // Initiate payment in super app
    //       const sa_request_payload = JSON.stringify({
    //         functionName: "initiatePayment",
    //         params: {
    //           orderPayload: response.orderPayload,
    //           authPayload: {
    //             xAPiKey: appSecret,
    //             xAccessToken: user.token,
    //           },
    //           callbackName: "callbacktocourier", // Define your callback handler
    //         },
    //       });

    //       // Check if Dashen Bank super app is available
    //       if (window.dashenbanksuperapp) {
    //         window.dashenbanksuperapp.send(sa_request_payload);
    //       } else {
    //         console.log("Dashen Bank Super App not found.");
    //       }
    //     } else {
    //       console.error("Payment order creation failed:", response.message);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error during payment order creation:", error);
    //   })
  };
  const callbacktocourier = (responseData) => {
    alert(`Payment callback: ${responseData}`);
    const response = JSON.parse(responseData);
    if (response.status && response.transactionStatus === "PAID") {
      // Prepare the request data for the first API call
      const reqData = {
        title: response.amount.title, // Replace with actual data fields from response
        amount: response.amount.total_amount, // Adjust based on response object structure
        trace_no: response.amount.merch_order_id,
        appId: response.amount.appid,
        message: response.message,
        issued_to: response.phoneNumber,
        status: response.status,
        transactionStatus: response.transactionStatus,
        created_date: new Date().toISOString(), // Capture the current date and time in ISO format
      };

      // Call the first API to process the payment
      axios
        .post(`${test_ip}admin/pay_payment_dashen_superapp`, reqData)
        .then((res) => {
          // Check if the first API call was successful
          if (res.data.success) {
            // Retrieve user data from localStorage
            // const cart = JSON.parse(localStorage.getItem('cart')); // Assume the cart is also stored in localStorage
            if (user) {
              // Prepare the request data for the second API call
              // user_id: '668ba6c9f211fa3df345f995',
              //       server_token: 'FJbcv5vgq7EdU4Pdsd1xq42hd2oau7Y3',
              //       cart_id: '67151ca9730067543e7eed88',
              //       delivery_type: '2',
              //       paid_by: '1',
              //       is_schedule_order: 'false',
              //       schedule_order_start_at: '',
              //       vehicle_id: '5b406c5dd2ddf8062d11b78a'
              const createOrderData = {
                user_id: user.user_id, // user ID from localStorage
                cart_id: cart_id,
                delivery_type: "2",
                paid_by: "1",
                is_schedule_order: "false",
                schedule_order_start_at: "",
                server_token: user.server_token,
                vehicle_id: orderPayment.vehicle_id,
              };

              // Call the second API to create the order
              axios
                .post(`${test_ip}api/user/create_order`, createOrderData)
                .then((orderRes) => {
                  console.log(
                    "User order created successfully:",
                    orderRes.data
                  );
                })
                .catch((error) => {
                  setError(["Order Creation Does Not Complete...."]);
                  console.error("Error creating user order:", error);
                });
            } else {
              setError(["Order Creation Does Not Complete...."]);
              console.error("User or cart data is missing from localStorage.");
            }
          }
        })
        .catch((error) => {
          setError(["Order Creation Does Not Complete...."]);
          console.error("Error processing payment:", error);
        });
    } else {
      setError(["Payment Processing Doesnot Complete...."]);
      console.error("Payment failed:", response.message);
    }
  };

  return (
    <div style={styles.container}>
      {/* App Bar */}
      <div style={styles.appBar}>
        <h1 style={styles.appBarTitle}>Checkout</h1>
      </div>

      <div style={styles.invoiceBox}>
        {/* Order Details Title */}
        <h1 style={styles.title}>Order Details</h1>

        <div style={styles.row}>
          <span>Sender:</span>
          <span style={styles.name_label}>{senderName}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Phone:</span>
          <span>{senderPhone}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Pickup Address:</span>
          <span>{pickupAddress}</span>
        </div>

        <hr style={styles.separator} />

        <div style={styles.row}>
          <span>Receiver:</span>
          <span style={styles.name_label}>{receiverName}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Phone:</span>
          <span>{receiverPhone}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Dropoff Address:</span>
          <span>{dropoffAddress}</span>
        </div>

        <hr style={styles.separator} />

        {/* Payment Details Section */}
        <h1 style={styles.title}>Payment Details</h1>
        {/* <div style={styles.row}>
          <span style={styles.label}>Time:</span>
          <span>{time} mins</span>
        </div> */}
        <div style={styles.row}>
          <span style={styles.label}>Distance:</span>
          <span>{distance.toFixed(2)} km</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Service Price:</span>
          <span>ETB {servicePrice}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Total Price:</span>
          <span>ETB {totalPrice}</span>
        </div>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loading />
          </div>
        ) : (
          <button style={styles.button} onClick={handlePlaceOrder}>
            Place Order
          </button>
        )}
        {!error.length == 0 ? (
          <Alert style={{ margin: "10px" }} severity="error">
            {error[0]}
          </Alert>
        ) : null}
        {/* Place Order Button */}
        {/* <button style={styles.button} onClick={handlePlaceOrder}>
          Place Order
        </button> */}
      </div>
    </div>
  );
};

// Responsive styles
// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "flex-start",
//     alignItems: "center",
//     backgroundColor: "white",
//     minHeight: "100vh",
//     padding: "20px",
//   },
//   appBar: {
//     width: "100%", // Full width of the container
//     backgroundColor: "white", // White background
//     padding: "10px 20px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     color: "black", // Black text color
//     marginBottom: "20px", // Space between app bar and invoice box
//     borderBottom: "1px solid #e0e0e0", // Optional: border at the bottom for separation
//   },
//   appBarTitle: {
//     fontSize: "20px", // Increased font size for better visibility
//     fontWeight: "bold",
//     color: "black", // Ensuring the color is black
//   },
//   invoiceBox: {
//     backgroundColor: "#f8f8f8",
//     borderRadius: "8px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//     padding: "20px",
//     width: "100%",
//     maxWidth: "600px",
//   },
//   title: {
//     textAlign: "center",
//     marginBottom: "20px",
//     fontSize: "14px", // Adjust the font size for better visibility
//     fontWeight: "bold", // Make the title bold
//     color: "black", // Set the title color to black
//   },
//   row: {
//     display: "flex",
//     justifyContent: "space-between",
//     padding: "10px 0",
//     borderBottom: "1px solid #e0e0e0",
//   },
//   name_label: {
//     fontWeight: "bold",
//   },
//   separator: {
//     margin: "20px 0",
//     border: "1px solid #e0e0e0",
//   },
//   button: {
//     width: "100%", // Full width of the invoice box
//     padding: "10px", // Padding for the button
//     backgroundColor: "red", // Red background
//     color: "white", // White text color
//     border: "none", // No border
//     borderRadius: "5px", // Slightly rounded corners
//     cursor: "pointer", // Pointer cursor on hover
//     fontSize: "16px", // Font size for the button
//     marginTop: "20px", // Margin above the button
//     transition: "background-color 0.3s ease", // Transition for hover effect
//   },
// };
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "white",
    minHeight: "100vh",
    padding: "20px",
    boxSizing: "border-box", // Ensure padding doesn't overflow
  },
  appBar: {
    width: "100%",
    backgroundColor: "white",
    padding: "10px 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "black",
    marginBottom: "20px",
    borderBottom: "1px solid #e0e0e0",
  },
  appBarTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "black",
  },
  invoiceBox: {
    backgroundColor: "#f8f8f8",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    width: "100%",
    maxWidth: "600px", // Ensure the invoice box doesn't become too wide
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "14px",
    fontWeight: "bold",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px",
    fontSize: "12px", // Smaller font size for better mobile layout
  },
  label: {
    // fontWeight: "bold",
  },
  name_label: {
    // fontWeight: "bold",
    color: "#333", // Slightly darker for better visibility
  },
  separator: {
    margin: "10px 0",
    borderTop: "1px solid #e0e0e0",
  },
  button: {
    width: "100%",
    backgroundColor: "red", // Red background
    color: "white",
    border: "none",
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: "10px",
    textAlign: "center",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
  },
  errorAlert: {
    margin: "10px 0",
  },

  // Mobile responsiveness
  "@media (max-width: 600px)": {
    appBarTitle: {
      fontSize: "18px", // Smaller font size for mobile
    },
    invoiceBox: {
      padding: "15px", // Reduce padding for smaller screens
    },
    title: {
      fontSize: "12px", // Smaller font size for better readability on mobile
    },
    row: {
      flexDirection: "column", // Stack rows vertically on mobile
      marginBottom: "10px", // Space between rows
      fontSize: "14px", // Slightly larger font size for better readability
    },
    label: {
      fontSize: "14px", // Adjust font size on mobile
    },
    button: {
      padding: "12px", // Larger button padding for easier clicking on mobile
      fontSize: "14px", // Adjust font size for mobile
    },
    loadingContainer: {
      marginTop: "15px", // Adjust spacing for loading indicator
    },
    errorAlert: {
      fontSize: "14px", // Make error messages readable on mobile
    },
  },

  // Adjustments for very small screens (e.g., < 400px width)
  "@media (max-width: 400px)": {
    appBarTitle: {
      fontSize: "16px", // Further reduce font size for very small screens
    },
    invoiceBox: {
      padding: "10px", // Even smaller padding
    },
    title: {
      fontSize: "10px", // Very small font size for very small screens
    },
    row: {
      fontSize: "12px", // Smaller font size
    },
    button: {
      padding: "10px", // Adjust button size for very small screens
      fontSize: "12px", // Smaller font size for mobile
    },
  },
};

// Export the component
export default CourierInvoice;
